import { QLoginRFC } from "../CoreApp/QLoginRFC";
import { Globals } from "../CoreApp/Globals";
import { AutoLoginState } from "./AutoLoginState";

export function ValidateCreds() {
  var WSMgr = Globals._wsMgr;
  var loginPanel = WSMgr.fLoginPanel;
  var doPublicLaunch = Globals._accountInfo.PublicURLLaunch();

  var un = "";
  var pw = "";
  var adminuserimp = "";
  var cc = "";
  var orgID = "";
  if (doPublicLaunch) un = Globals._accountInfo.fURLUser;

  if (loginPanel && !doPublicLaunch) {
    un = loginPanel.GetUserName();
    un = un.trim();
    pw = loginPanel.GetPassword();
    if (loginPanel.fInAdminMode) adminuserimp = loginPanel.GetAdminUser();
    if (loginPanel.fLoginMode == enumLoginMode.enterOrgMode)
      orgID = document.getElementById("orgpicker").value;
  }

  var tryAutoLog = AutoLoginState() && !doPublicLaunch;
  var loginFail = un.length == 0 && !tryAutoLog;
  /*
	if (!loginFail)
	{
		if (doPublicLaunch)
		   loginFail = false;
		else
		{
			var gotPW = pw.length > 0;
			if (!gotPW)
				gotPW = (hashpw != null && hashpw.length > 0);
			loginFail = !gotPW;
		}
	}
	*/
  if (loginFail) {
    if (loginPanel) loginPanel.ResetLoginPanel("loginfail");
  } else {
    var sparam = Globals._accountInfo.GetSParam();
    var settings = {
      s: sparam,
      uiprofile: Globals._accountInfo.fUIProfile,
      delegatedUserMFA: Globals._accountInfo.fDelegatedUserMFA
    };
    if (Globals._accountInfo.fURLAction) settings["action"] = Globals._accountInfo.fURLAction;
    if (adminuserimp != "") settings["adminuser"] = adminuserimp;
    if (doPublicLaunch) settings["publiclaunch"] = doPublicLaunch;
    if (orgID) settings["orgID"] = orgID;
    if (cc) settings["cc"] = cc;
    if (tryAutoLog && !loginPanel.fInAdminMode) {
      if (localStorage["cookie"] && !loginPanel.fManualLogin)
        settings["token"] = localStorage["cookie"];
      else settings["autologin"] = true;
    }
    if (loginPanel) loginPanel.EnableLoginControls(false);
    WSMgr.DoAppLoadingAnimation();
    var loginRFC = new QLoginRFC();
    loginRFC.InitLoginRFC(WSMgr);
    loginRFC.SetParams(un, pw, false, doPublicLaunch, settings); //hashpw
    Globals._rfcMgr.QueueRFC(loginRFC);
  }
}
